import React, { PureComponent } from "react";
import { connect } from "react-redux";

import Search from "./Search";
import Filter from "Common/Filter";
import styles from "./Header.local.scss";
import _ from "i18n";

class HeaderComponent extends PureComponent {
  render() {
    const { community } = this.props;
    let h1 = <h1>{_("Discover the images, videos and documents")}</h1>;
    let tabs = [];
    if (community) {
      const { name, abbreviation, mediaSettings } = community;
      tabs =
        mediaSettings &&
        mediaSettings.preferences &&
        mediaSettings.preferences.generalTypes
          ? mediaSettings.preferences.generalTypes.split(",")
          : [];
      h1 = (
        <h1>
          {_("Discover the images, videos and documents of your community:")}
          <strong>{abbreviation || name}</strong>
        </h1>
      );
    }

    return (
      <div className={styles.header}>
        {h1}
        <Search />
        <Filter tabs={[...tabs, "ALBUM"]} withSearch={false} />
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(HeaderComponent);



// WEBPACK FOOTER //
// ./src/components/Community/Header/HeaderComponent.js